import request from '@/utils/request'

// 获取南向资金 历史走势 跟  指数K线
export function getNxzjCharts ( query ) {
    return request( {
        url: '/Lssj/getNxzjCharts',
        method: 'get',
        params: query
    } )
}

// 获取北向资金 历史走势 跟  指数K线
export function getBxzjCharts ( query ) {
    return request( {
        url: '/Lssj/getBxzjCharts',
        method: 'get',
        params: query
    } )
}

//  获取南北向资金历史数据 明细
export function bxzjLsmx ( query ) {
    return request( {
        url: '/Lssj/bxzjLsmx',
        method: 'get',
        params: query
    } )
}

//  获取北向资金老版本资金净流入
export function bxzjOldJlr ( query ) {
    return request( {
        url: '/Lssj/bxzjOldJlr',
        method: 'get',
        params: query
    } )
}

//  获取北向资金历史数据 明细成交总额
export function bxzjCjzelsmx ( query ) {
    return request( {
        url: '/Lssj/bxzjCjzelsmx',
        method: 'get',
        params: query
    } )
}

//  获取北向资金k线和折线数据（新）
export function bxzjCjzelsmxLine ( query ) {
    return request( {
        url: '/Lssj/bxzjCjzelsmxLine',
        method: 'get',
        params: query
    } )
}
